(() => {
  function init(nav) {
    if (nav.dataset.taxonomyReady) return;
    nav.dataset.taxonomyReady = 'true';
    const desktop = window.matchMedia('(min-width: 990px)');
    const update = () => nav.querySelectorAll('[data-taxonomy-group]').forEach(group => { group.open = desktop.matches; });
    update(); desktop.addEventListener('change', update);
    nav.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const root = event.target.closest('.site-nav__details');
      if (root && root.open) { root.open = false; root.querySelector('summary').focus(); event.preventDefault(); }
      else if (nav.classList.contains('is-open')) { const toggle = document.querySelector('[data-menu-toggle]'); if (toggle) { toggle.click(); toggle.focus(); event.preventDefault(); } }
    });
  }
  document.querySelectorAll('[data-taxonomy-nav]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-taxonomy-nav]').forEach(init));
})();
